import { useMutation } from 'react-query';
import { useStore } from '../../../store';
import { httpService } from '../../../services/http.service';
import { BASE_URL } from '../../../constants/endpoints';

interface IProps {
    savingAmount: number;
}
export const useSetUpBucketMutation = () => {
  const { customerId } = useStore(state => state.user);
  return useMutation(
    'useSetUpBucketMutation',
    async ({ savingAmount }: IProps) => {
      await httpService.post(
        `${BASE_URL}/api/v2/user/${customerId}/bucket/emergency`,
        {
          weeklyAmount: savingAmount,
          activate: true,
          autoSave: true,
        },
      );
    },
    {
      onError: (e) => {
        console.error(e);
      },
    },
  );
};
